import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import PubSub from 'pubsub-js';
import { CONTENT_REPLICATOR } from '../../../queries/titleContent';
import { ReplicatorForm } from '../components/replicatorForm';

const Replicator: React.FC = () => {
  return (
    <Mutation
      mutation={CONTENT_REPLICATOR}
      update={async () => {
        PubSub.publish('CLOSE-DRAWER');
      }}
    >
      {(replicateContent: any) => <ReplicatorForm query_f={replicateContent} />}
    </Mutation>
  );
};

export default Replicator;
